import Passcode from './Passcode';
import enhance from './PasscodeContainer';

export default enhance(Passcode);

export * from './actions';
export { default as reducer } from './reducer';



// WEBPACK FOOTER //
// ./src/app/passcode/index.js